export default __webpack_public_path__ + "static/media/F0002.690f7fb9.png";